import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// A task's "Open in chart" lands on /visit/<visit>?orders=paperwork&paperwork=<formId>.
// Each arrival opens Orders on that form once: `clear` (Orders closed) forgets
// it, so the next Orders click opens as usual, while following a link again —
// a new navigation, even to the same URL — opens it again. `leave` is for
// someone the chart itself isn't for (who came only for the form): it takes
// them back where they followed the link from — home, if it was opened on its
// own — rather than leaving them on the visit note.
// Returns { link: { key, tab, paperworkId } | null, clear, leave }.
export default function useOrdersDeepLink(canOpen) {
  const [searchParams] = useSearchParams();
  const { key } = useLocation();
  const navigate = useNavigate();
  const orders = searchParams.get("orders");
  const paperworkId = searchParams.get("paperwork");
  const [link, setLink] = useState(null);
  const handled = useRef(null);

  useEffect(() => {
    if (orders !== "paperwork" || !canOpen || handled.current === key) return;
    handled.current = key;
    setLink({ key, tab: "paperwork", paperworkId: paperworkId || null });
  }, [orders, paperworkId, canOpen, key]);

  const clear = useCallback(() => setLink(null), []);
  // The first entry of a session is keyed "default": nothing to go back to.
  const leave = useCallback(() => {
    setLink(null);
    if (key && key !== "default") navigate(-1);
    else navigate("/", { replace: true });
  }, [key, navigate]);
  return { link, clear, leave };
}
